import {
	Box,
	Button,
	Flex,
	Modal,
	ModalBody,
	ModalCloseButton,
	ModalContent,
	ModalFooter,
	ModalHeader,
	ModalOverlay,
} from "@chakra-ui/react";
import TrashIcon from "../icons/TrashIcon";
import { ReactNode } from "react";

type ValidationModalProps = {
	title?: string;
	icon?: ReactNode;
	description?: string;
	isOpen: boolean;
	onClose: () => void;
	onValidate?: () => void;
};

function ValidationModal({
	title,
	icon,
	description,
	isOpen,
	onClose,
	onValidate,
}: ValidationModalProps) {
	if (!title) {
		title = "Êtes-vous sur de cette action ?";
	}
	if (!description) {
		description = "Êtes-vous sur de cette action ? Elle est irreversible.";
	}
	return (
		<Modal isOpen={isOpen} onClose={onClose} isCentered size={"xl"}>
			<ModalOverlay bg="blackAlpha.300" backdropFilter="blur(6.9px)" />
			<ModalContent>
				<ModalHeader borderBottom="solid 1px #E2E8F0">
					<Flex>
						<Flex
							w="48px"
							h="48px"
							bg="zinc.50"
							border="solid 1px"
							borderColor={`red.100`}
							justifyContent="center"
							alignItems="center"
							borderRadius={100}
							mr="8px"
						>
							{icon !== undefined && icon}
							{icon === undefined && (
								<TrashIcon w="24px" h="24px" color="red.600"></TrashIcon>
							)}
						</Flex>
						<Box lineHeight="48px">{title}</Box>
					</Flex>
				</ModalHeader>
				<ModalCloseButton />
				<ModalBody>{description}</ModalBody>
				<ModalFooter>
					<Flex w="100%" justifyContent={"space-between"} gap={4}>
						<Button
							w="100%"
							variant="outlined"
							color="red.700"
							onClick={onClose}
						>
							Annuler
						</Button>
						<Button
							w="100%"
							variant="solid"
							color="white"
							bgColor="red.600"
							onClick={onValidate}
						>
							Valider
						</Button>
					</Flex>
				</ModalFooter>
			</ModalContent>
		</Modal>
	);
}

export default ValidationModal;
